import axios from '@/libs/api.request'

// 查询安装工列表
export function installerList(data) {
  return axios.request({
    url: '/installer/list',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 查询安装工详情
export function installerInfo(id) {
  return axios.request({
    url: `/installer/info/${id}`,
    method: 'get'
  })
}

// 新增安装工
export function addInstaller(data) {
  return axios.request({
    url: '/installer/save',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 修改安装工
export function updateInstaller(data) {
  return axios.request({
    url: '/installer/update',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 删除安装工
export function delInstaller(ids) {
  return axios.request({
    url: '/installer/delete',
    method: 'post',
    data: ids,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
